import { EngagementProcess } from '../slices/marketplace/timeline/models/engagement-process.model';

export const isTransactionDocumentsAvailable = (
    engagementProcess: EngagementProcess | null | undefined
): boolean =>
    engagementProcess?.buyers?.some((buyer) => buyer.isTransactionDocumentsAvailable) ?? false;
